var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import useTranslation from '../../../../hooks/use-translation';
import { StyledFlex, StyledText } from '../../../subcomponents';
import SuccessGraphic from '../Graphic';
var Banner = function (_a) {
    var currentFlow = _a.currentFlow;
    var i18n = useTranslation();
    return (_jsx(Inset, __assign({ vertical: "xlarge", top: "large", bottom: "xlarge" }, { children: _jsxs(StyledFlex, __assign({ direction: "column", alignItems: "center" }, { children: [_jsx(SuccessGraphic, {}), _jsx(Stack, {}), _jsx(StyledText, __assign({ weight: "bold", align: "center", size: "medium" }, { children: i18n("".concat(currentFlow, ".successHeading")) })), _jsx(Stack, { size: "medium" }), _jsx(StyledText, __assign({ align: "center" }, { children: i18n('common.successSubHeading') }))] })) })));
};
export default Banner;
//# sourceMappingURL=index.js.map